// extracted by mini-css-extract-plugin
export var brain = "Brain-module--brain--1YSUb";
export var brainPrimary = "Brain-module--brain--primary--2gyXl";